// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvtFullSize_wrapper__9asi0","qrBlock":"AdvtFullSize_qrBlock__RKDq+","qrCode":"AdvtFullSize_qrCode__yACeH"};